<style lang="scss" scoped>
@import '@/view/qwAuth/index.scss';
.bindPhoneDialog {
  width: 100%;
  text-align: center;
  .el-dialog__body {
    padding-top: 0;
    padding-bottom: 50px;
    margin-top: -20px;
  }
  .title {
    margin: 20px 0;
    font-size: 18px;
    color: #333;
  }

  .form {
    text-align: left;
    margin-bottom: 40px;
    padding-left: 20px;
    &_label {
      font-size: 14px;
      font-family:
        PingFangSC-Regular,
        PingFang SC;
      font-weight: 400;
      color: #888888;
      margin-bottom: 10px;
    }

    .form-phone {
      margin-bottom: 16px;
    }
  }
  .captcha-embed {
    min-height: 48px;
    margin-bottom: 8px;
  }
  .btn {
    margin-right: 0;
    border-radius: 2px;
    border: 1px solid #2083e0;
    background-color: #fff;
    color: #2083e0;
  }
  .loginBtn {
    margin-bottom: 8px;
  }
}
</style>
<template>
  <div class="bindPhoneDialog">
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      class="dialog"
      width="370px"
    >
      <img
        style="height: 160px; margin-top: -50px"
        :src="require('@/assets/img/qwLogin/bindPhone/2.svg')"
        alt=""
      >
      <div class="title">
登录成功，绑定手机号码
</div>
      <div class="form">
        <div class="form-phone">
          <div class="form_label">
手机号码
</div>
          <el-input
            v-model="form.phoneNumber"
            style="width: 290px !important"
            placeholder="请输入手机号码"
            class="input-m m-r-6 input__inner custom_button"
            clearable
          />
        </div>
        <div class="captcha-embed">
          <div id="nc" />
        </div>

        <div class="form-code">
          <div class="form_label">
验证码
</div>
          <div style="display: flex; width: 290px">
            <el-input
              v-model="form.code"
              placeholder="请输入验证码"
              class="input-m m-r-6 input__inner custom_button custom_button_sm"
              clearable
            />
            <!-- 由阿里云 initAliyunCaptcha 的 button 绑定点击：先滑块，通过后走 captchaVerifyCallback 再发短信 -->
            <el-button
              id="btn-send-sms"
              type="primary"
              plain
              class="btn"
            >
              {{ codeTime == 0 ? '获取验证码' : `${codeTime}s后重新发送` }}
            </el-button>
          </div>
        </div>
      </div>
      <el-button
        id="btn-bind-submit"
        type="primary"
        class="loginBtn"
        style="margin-bottom: 8px"
        @click="bindPhone"
      >
        立即使用
      </el-button>
    </el-dialog>
  </div>
</template>
<script>
import bindPhoneMixin from '../../mixins/bindPhone.js'

export default {
  name: 'BindPhoneDialog',
  mixins: [bindPhoneMixin],
  props: {},
  data () {
    return {
      dialogVisible: true,
      captchaInstance: null
    }
  },
  mounted () {
    this.$nextTick(() => this.initAliyunCaptchaSafe())
  },
  beforeDestroy () {
    if (this.captchaInstance && typeof this.captchaInstance.destroy === 'function') {
      try {
        this.captchaInstance.destroy()
      } catch (e) {
        /* ignore */
      }
    }
    this.captchaInstance = null
  },
  methods: {
    initAliyunCaptchaSafe () {
      if (typeof window.initAliyunCaptcha !== 'function') {
        this.$message.error('验证码脚本未加载，请刷新页面重试')
        return
      }
      const sceneId =
        process.env.VUE_APP_ALIYUN_CAPTCHA_SCENE_ID || '12l4ca6l'
      window.initAliyunCaptcha({
        SceneId: sceneId,
        mode: 'embed',
        element: '#nc',
        button: '#btn-send-sms',
        captchaVerifyCallback: async (captchaVerifyParam) => {
          return this.requestPhoneCodeAfterCaptcha(captchaVerifyParam)
        },
        onBizResultCallback: (bizResult) => {
          if (bizResult === false) {
            this.$message.warning('验证未通过，请重试')
          }
        },
        getInstance: (instance) => {
          this.captchaInstance = instance
        },
        // 文档：滑块 width 最小 320px，与表单宽度对齐
        slideStyle: { width: 320, height: 40 },
        language: 'cn',
        immediate: false,
        onError: (err) => {
          console.error('Aliyun captcha error', err)
          this.$message.error('验证码加载失败，请刷新重试')
        }
      })
    }
  }
}
</script>
